// 组件对象，大写
import selectOfModalTable from './selectOfModalTable.vue'
export default selectOfModalTable
